<template>
  <v-card>
    <v-form ref="startDateInfo" >
      <v-card-text >
        <div class="c-d-flex c-align-center">
          <date-picker-with-max
              v-model="startDateModelValue"
              :date-only="true"
          >
            <template #activator>
              <v-text-field
                  label="Start Date"
                  :rules="[validationRules.required]"
                  :value="startDateDisplayStr"
                  readonly
              >
              </v-text-field>
            </template>
          </date-picker-with-max>
          <v-text-field
              prefix="x"
              type="number"
              label="Cost Multiplier"
              v-model.number="modelValue.costMultiplier"
              :rules="[validationRules.required]"
          
          />
        </div>
        <div class="c-d-flex c-align-center">
          <v-text-field
              prefix="$"
              type="number"
              label="Input per M tokens"
              v-model.number="modelValue.mTokenInput"
              :rules="[validationRules.required]"
          
          />
          <v-text-field
              prefix="$"
              type="number"
              label="Output per M tokens"
              v-model.number="modelValue.mTokenOutput"
              :rules="[validationRules.required]"
          />
        </div>
      </v-card-text>
    </v-form>
    
    
    <v-card-actions>
      <v-btn
          v-if="showRemove"
          flat
          color="error"
          @click="remove"
      >
        Remove
      </v-btn>
      <v-spacer/>
      <v-btn
          flat
          color="disabled"
          @click="cancel"
      >
        Cancel
      </v-btn>
      <v-btn
          color="secondary"
          @click="save"
      >
        Done
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import {validationRules} from "@/codeFunctions";
import format from "date-fns/format";
import DatePickerWithMax from "@/components/General/DatePickerWithMax.vue";

export default {
  components: {DatePickerWithMax},
  
  props: {
    showRemove: {
      type: Boolean,
      default: true,
    },
    value: {
      type: Object,
      default: () => ({
        fk_model: 0,
        startDate: new Date(),
        mTokenOutput: 0,
        mTokenInput: 0,
        costMultiplier: 1
      })
    },
  },
  data() {
    return {
      modelValue: {
        fk_model: 0,
        startDate: new Date(),
        mTokenOutput: 0,
        mTokenInput: 0,
        costMultiplier: 1
      },
    }
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(val) {
        this.modelValue = {
          fk_model: this.value.fk_model || 0,
          startDate: this.value.startDate || new Date(),
          mTokenOutput: this.value.mTokenOutput || 0,
          mTokenInput: this.value.mTokenInput || 0,
          costMultiplier: this.value.costMultiplier || 1,
        }
      }
    }
  },
  methods: {
    remove() {
      this.$emit('remove', this.value)
      this.$parent.$parent.save()
    },
    cancel() {
      this.$parent.$parent.save()
    },
    save() {
      if (!this.$refs.startDateInfo.validate())
        return this.$snack.error('Please fill out all required fields');
      this.$emit('input', this.modelValue)
      this.$parent.$parent.save()
    }
  },
  computed: {
    validationRules() {
      return validationRules
    },
    startDateDisplayStr() {
      return format(this.modelValue.startDate, 'YYYY-MM-DD')
    },
    startDateModelValue: {
      get() {
        return format(this.modelValue.startDate, 'YYYY-MM-DD')
      },
      set(val) {
        this.modelValue.startDate = new Date(val)
      }
    }
  },
}
</script>


<style scoped>

</style>